/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Swedish (sv) string table — Shop landing page
   English is the source of truth in the HTML; this file supplies the
   Swedish counterpart for each shop.* key. Missing keys fall back to
   English (see i18n.js). Claim-bearing copy: faithful renderings only,
   no strengthening or embellishment. The only standing discount is the
   routine-builder 10% (auto-applied at checkout for 2+ serums).

   House voice: calm, exact, short. No em dashes in prose (use periods,
   commas, or the mid-dot · ). EXCEPTION: combo card labels keep the
   existing em dash ("Serum C — Brightening"), mirrored faithfully.
   Product names, prices and proper nouns stay as-is.
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.sv = window.TD_I18N.sv || {};
  Object.assign(window.TD_I18N.sv, {

    /* ── Nav (page-specific) ── */
    'shop.nav.build': 'Bygg en rutin',

    /* ── Serum grid ── */
    'shop.grid.title': 'Hudvård utan kompromiss',
    'shop.addcart': 'Lägg i varukorg',
    'shop.time.day': 'Dag',
    'shop.time.night': 'Natt',
    'shop.time.both': 'Dag &amp; natt',
    'shop.card.c.benefit': 'Skyddar, ger lyster och gör huden fastare med ren C-vitamin.',
    'shop.card.a.benefit': 'Retinoldriven förnyelse medan du sover.',
    'shop.card.o.benefit': 'Ger energi åt cellerna och återställer synlig lyster.',
    'shop.card.m.benefit': 'Reparerar fuktbarriären. Djupt och varaktigt.',
    'shop.card.r.benefit': 'Gör huden fastare och återställer den. Minskar blemmor och ojämn struktur över tid.',

    /* ── Benefit strip ── */
    'shop.strip.1.t': 'Inga konserveringsmedel',
    'shop.strip.1.b': 'Lufttät, UV-beständig förpackning skyddar varje aktiv ingrediens. Inga stabilisatorer, inga kompromisser.',
    'shop.strip.2.t': 'Transdermal leverans',
    'shop.strip.2.b': 'Ett vattenfritt bärarsystem levererar aktiva vitaminer förbi ytan till dermis, där kollagensyntes och cellförnyelse sker.',
    'shop.strip.3.t': '2 års hållbarhet',
    'shop.strip.3.b': 'Inget vatten betyder ingen bakterietillväxt. Stabilt och verksamt från första användningen till den sista.',
    'shop.strip.4.t': 'Djurförsöksfritt',
    'shop.strip.4.b': 'Aldrig testat på djur. Kliniskt utvecklat, ansvarsfullt levererat.',

    /* ── Combo builder ── */
    'shop.combo.label': 'Bygg din rutin',
    'shop.combo.h2': 'Två serum eller fler?<br><em>Tio procent rabatt.</em>',
    'shop.combo.c.name': 'Serum C — Lyster',
    'shop.combo.c.desc': 'C-vitamin · Dag · Mörka fläckar &amp; lyster',
    'shop.combo.a.name': 'Serum A — Förnyelse',
    'shop.combo.a.desc': 'A-vitamin · Natt · Cellförnyelse &amp; struktur',
    'shop.combo.o.name': 'Serum O — Syresättande',
    'shop.combo.o.desc': 'O-vitamin · Dag · Cellulär vitalitet &amp; ton',
    'shop.combo.m.name': 'Serum M — Fukt',
    'shop.combo.m.desc': 'M-vitamin · Dag + natt · Återfuktning &amp; barriär',
    'shop.combo.r.name': 'Serum R — Antioxidant',
    'shop.combo.r.desc': 'Resveratrol · Dag + natt · Skydd &amp; livslängd',

    /* ── Combo summary sidebar ── */
    'shop.concern.label': 'Handla efter hudbehov',
    'shop.concern.placeholder': 'Välj ett hudbehov…',
    'shop.concern.firmness': 'Fasthet',
    'shop.concern.brightness': 'Lyster',
    'shop.concern.hydration': 'Återfuktning',
    'shop.concern.finelines': 'Fina linjer',
    'shop.concern.darkspots': 'Mörka fläckar',
    'shop.concern.texture': 'Struktur',
    'shop.concern.acnescars': 'Akneärr',
    'shop.concern.dullness': 'Glåmig hud',
    'shop.sum.title': 'Din rutin',
    'shop.sum.empty': 'Välj serum för att börja',
    'shop.sum.discount': 'Rutinrabatt (10%)',
    'shop.sum.total': 'Totalt',
    'shop.sum.addbtn': 'Lägg rutinen i varukorgen',
    'shop.sum.note': 'Fri frakt världen över · 2 års hållbarhet garanteras',

    /* ── Sample / Discovery Kit ── */
    'shop.samp.eyebrow': 'Osäker på var du ska börja?',
    'shop.samp.title': 'Prova alla fem<br><em>för $70.</em>',
    'shop.samp.body': 'Transderma Discovery Kit innehåller fickformat av alla fem serum. Det är så de flesta av våra långvariga kunder först hittade oss.',
    'shop.samp.cta': 'Skaffa Discovery Kit',
    'shop.samp.fine': '$5 frakt världen över · Skickas från Stockholm',
    'shop.samp.f1.t': 'Alla fem serum',
    'shop.samp.f1.b': 'Fickformat av C, A, O, M och R, 3 ml vardera. Cirka 7 dagars konsekvent användning per flaska.',
    'shop.samp.f2.t': 'Alla fem, sida vid sida',
    'shop.samp.f2.b': 'Kör varje formel genom din rutin samma vecka och hitta kombinationerna som fungerar för din hud.',
    'shop.samp.f3.t': 'Inget åtagande',
    'shop.samp.f3.b': 'Du vet inom en vecka om Transderma är något för dig. De flesta vet inom några dagar.',

    /* ── Gift voucher ── */
    'shop.gift.title': 'Ge bort <em>Transderma</em> i present',
    'shop.gift.sub': 'En digital presentkod som levereras via e-post. Kan lösas in på varje serum och Discovery Kit.',
    'shop.gift.btn': 'Köp nu',

    /* ── Discovery Kit product page (shopify-theme/templates/product.transderma-discovery-kit.liquid) ── */
    'shop.kit.crumb.home': 'Hem',
    'shop.kit.crumb.current': 'Discovery Kit',

    /* Hero */
    'shop.kit.eyebrow': 'Fem vitaminserum · Ett kit',
    'shop.kit.tagline': 'Fickformatsversioner av alla fem Transderma-serum. Cirka 7 dagars daglig användning över hela kittet. Prova hela systemet innan du bestämmer dig för flaskor i full storlek.',
    'shop.kit.price.meta': 'Fem miniflaskor · 3 ml vardera',
    'shop.kit.addcart': 'Lägg i varukorg · $70',
    'shop.kit.soldout': 'Slutsåld · tillbaka snart',
    'shop.kit.reserve': 'Reservera ditt kit',

    /* Hero meta */
    'shop.kit.meta.inside': 'Vad ingår',
    'shop.kit.meta.inside.v': '5 miniflaskor · 3 ml vardera',
    'shop.kit.meta.lasts': 'Räcker',
    'shop.kit.meta.lasts.v': '~7 dagars daglig användning',
    'shop.kit.meta.formula': 'Formel',
    'shop.kit.meta.formula.v': '100% aktiv, inget vatten',
    'shop.kit.meta.shelf': 'Hållbarhet',
    'shop.kit.meta.shelf.v': '2 år, kraftfull hela tiden',

    /* What's inside */
    'shop.kit.inside.label': 'Vad ingår',
    'shop.kit.inside.title': 'Fem miniflaskor.<br><em>En komplett rutin.</em>',
    'shop.kit.inside.intro': 'Varje miniflaska rymmer tillräckligt med serum för ungefär 7 dagars daglig applicering. Använd dem var för sig, lager dem morgon och kväll, eller testa kombinationer mot dina hudbehov.',
    'shop.kit.card.time.day': 'Dag',
    'shop.kit.card.time.night': 'Natt',
    'shop.kit.card.time.both': 'Dag + natt',
    'shop.kit.card.c.desc': 'Ren C-vitamin. Ger lyster, skyddar, jämnar ut tonen.',
    'shop.kit.card.a.desc': 'Retinol. Cellförnyelse och struktur, medan du sover.',
    'shop.kit.card.o.desc': 'PQQ. Cellulär energi, vitalitet, klarhet.',
    'shop.kit.card.m.desc': 'Hyaluronsyra. Återfuktning, fyllighet, barriärstöd.',
    'shop.kit.card.r.desc': 'Resveratrol. Antioxidativt försvar och livslängd.',

    /* Why try the kit */
    'shop.kit.why.label': 'Varför börja här',
    'shop.kit.why.title': 'Hitta din rutin <em>innan</em> du bestämmer dig.',
    'shop.kit.why.intro': 'En flaska i full storlek kostar $175 och räcker flera veckors daglig användning. Discovery Kit är det enklaste sättet att ta reda på vilka serum som fungerar på din hud, och vilka kombinationer som verkligen gör skillnad för dina specifika hudbehov.',
    'shop.kit.why.1.t': '~7 dagar av riktig användning.',
    'shop.kit.why.1.b': 'Tillräckligt med serum för att applicera morgon och kväll i ungefär en vecka och börja se förändringar i struktur, ton och återfuktning. Det här är inget prov, det är en fungerande rutin.',
    'shop.kit.why.2.t': 'Alla fem, sida vid sida.',
    'shop.kit.why.2.b': 'Kör varje formel genom din morgon- och kvällsrutin samma vecka. Kittet är det snabbaste sättet att lära sig vilka kombinationer som verkligen gör skillnad för din hud.',
    'shop.kit.why.3.t': 'Alla fem för mindre än en halv flaska.',
    'shop.kit.why.3.b': 'Ett enda Transderma-serum i full storlek kostar $175. Kittet ger dig alla fem för $70: det billigaste sättet att ta reda på vilka formler din hud faktiskt svarar på innan du bestämmer dig.',

    /* How it works */
    'shop.kit.how.label': 'Så fungerar det',
    'shop.kit.how.title': 'Sju dagar. <em>En upptäckt.</em>',
    'shop.kit.how.intro': 'De flesta kunder vet inom fem dagar. Här är vägen de flesta tar.',
    'shop.kit.how.s1.t': 'Dag 1 · Öppna',
    'shop.kit.how.s1.b': 'Öppna kittet. Välj det hudbehov som matchar ditt: lyster, förnyelse eller återfuktning.',
    'shop.kit.how.s2.t': 'Dag 1–3 · Testa',
    'shop.kit.how.s2.b': 'Applicera din rutin morgon och kväll. Två droppar, intryckta på ren hud. Låt varje lager absorberas i 30 sekunder.',
    'shop.kit.how.s3.t': 'Dag 4–7 · Förfina',
    'shop.kit.how.s3.b': 'Vid dag sju vet du vilka serum din hud svarar på. Byt rutin, lager annorlunda eller förenkla till två.',
    'shop.kit.how.s4.t': 'Dag 8 · Skala upp',
    'shop.kit.how.s4.b': 'Beställ flaskor i full storlek av de serum som fungerade, i den rutin du byggde. Två eller fler flaskor = 10% rabatt.',

    /* Delivery / returns */
    'shop.kit.del.shipping.t': 'Frakt',
    'shop.kit.del.shipping.b': 'Fast frakt på $5 världen över. Skickas från Stockholm, vanligtvis 3–7 arbetsdagar. <a href="/pages/shipping-returns">Fullständiga fraktuppgifter</a>.',
    'shop.kit.del.returns.t': 'Returer',
    'shop.kit.del.returns.b': 'När det öppnats kan Discovery Kit inte återbetalas. Oöppnade kit kan returneras inom 14 dagar. <a href="/pages/shipping-returns">Returpolicy</a>.',
    'shop.kit.del.approved.t': 'Godkänt &amp; registrerat',
    'shop.kit.del.approved.b': 'Laboratoriegodkänt av Läkemedelsverket. Registrerat enligt EU:s kosmetikalagstiftning. Aldrig testat på djur.'

  });
})();
